import { useContext, useMemo } from "react";
import { WebContext } from "../Utility";
const useFeaturedListings = (key, limit = null) => {
  const websiteData = useContext(WebContext) || {};
  const { memberProfile = {} } = websiteData;

  const arrayData = useMemo(() => {
    if (!key) return [];

    let arr = [];
    const memberData = memberProfile[key];
    const websiteKeyData = websiteData[key];

    if (Array.isArray(memberData)) {
      arr = memberData;
    } else if (Array.isArray(websiteKeyData)) {
      arr = websiteKeyData;
    }

    if (limit && Number.isInteger(limit) && limit > 0) {
      arr = arr.slice(0, limit);
    }

    return arr;
  }, [key, limit, memberProfile, websiteData]);
  return arrayData;
  
};

export default useFeaturedListings;
